document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".app-slider");
  if (!slider) return;

  const track = slider.querySelector(".app-slider-track");
  const slides = slider.querySelectorAll(".app-slide");
  const prevBtn = slider.querySelector(".app-slider-btn.prev");
  const nextBtn = slider.querySelector(".app-slider-btn.next");
  const descItems = slider.querySelectorAll(".app-slide-desc");

  let currentIndex = 0;
  let autoPlayTimer;
  let manualPauseTimer;

  // --- Einstellungen aus dem Liquid (data-Attribute) ---
  const autoPlayEnabled = true;
  const autoPlayInterval = 5000;
  const manualPauseDuration = 7000;

  // --- Grundfunktionen ---
  function updateSlider() {
    const slideWidth = slides[0].clientWidth;
    track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
    descItems.forEach((desc, i) => {
      desc.classList.toggle("is-hidden", i !== currentIndex);
    });
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    updateSlider();
  }

  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateSlider();
  }

  // --- AutoPlay Logik ---
  function startAutoPlay() {
    if (!autoPlayEnabled) return;
    stopAutoPlay();
    autoPlayTimer = setInterval(nextSlide, autoPlayInterval);
  }

  function stopAutoPlay() {
    clearInterval(autoPlayTimer);
  }

  // --- Manuelle Pause nach User-Interaktion ---
  function pauseAutoPlayAfterManual() {
    stopAutoPlay(); // sofort stoppen
    clearTimeout(manualPauseTimer); // falls noch ein alter Timer läuft
    manualPauseTimer = setTimeout(() => {
      startAutoPlay(); // nach 10s wieder starten
    }, manualPauseDuration);
  }

  // --- Button Navigation ---
  prevBtn.addEventListener("click", () => {
    prevSlide();
    pauseAutoPlayAfterManual();
  });

  nextBtn.addEventListener("click", () => {
    nextSlide();
    pauseAutoPlayAfterManual();
  });

  // --- Touch Navigation ---
  let startX = 0;
  track.addEventListener("touchstart", (e) => (startX = e.touches[0].clientX));
  track.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) prevSlide();
      else nextSlide();
      pauseAutoPlayAfterManual();
    }
  });

  // --- Optional: AutoPlay pausieren bei Hover ---
  slider.addEventListener("mouseenter", stopAutoPlay);
  slider.addEventListener("mouseleave", startAutoPlay);

  // --- Initialisierung ---
  window.addEventListener("resize", updateSlider);
  updateSlider();
  startAutoPlay();
});
